import API from "../services/apiservices";

async function getid() {
  await API.getLocalDBDocument("menusStore").then((doc) => {
    if (doc && doc.data.Success) {
      return doc.data.Data[0].id;
    } else {
      return 0;
     }
  });
}

export default {
  namespaced: true,
  namespace: "menusStore",

  state: {
    storename: "menusStore",
    menus: {
      idMenu: 0,
      api: null,
      data: [],
      error: null
    },
  },

  getters: {
    gtxStore: () => ({name: "menusStore", route: "Servicos/APISolucoesMenus/Get", setter: "setMenus"}),
    gtxMenus: (state) => state.menus,
    gtxMenus_data: (state) => state.menus.data || [],
    gtxMenus_GetById: (state) => (idMenu) => state.menus.data.find(f => f.idMenu == idMenu) || {value: 0, text: ""},
    gtxMenus_selected: (state, getters) => state.menus.data.find(f => f.idMenu == getters.gtxMenus_id),
    gtxMenus_select: (state) => (id) => state.menus.data.find(f => f.id == id),
    gtxMenus_id: (state) => state.menus.idMenu,
    gtxMenus_title: (state, getters) => {
      const data = state.menus.data.find(f => f.idMenu == getters.gtxMenus_id);
      return data ? data.title : "";
    },
    gtxMenus_error: (state) => state.menus.error,
  },

  mutations: {
    setMenus: (state, menus) => (state.menus = {api: menus.apiresponse, data: menus.data, idMenu: menus.data[0].idMenu, error: null}),
    setMenusid: (state, idMenu) => (state.menus.idMenu = idMenu),
    setMenusdata: (state, data) => (state.menus.data = data),
  },

  actions: {
    actMenusGet({ commit, getters }) {
      
      // tem que definir um getter com os dados da store conforme o exemplo:
      // gtxStore: () => ({name: "menusStore", route: "Servicos/menus/Get", setter: "setMenus"}),

      // verifica a última atualização da store ...
      return new Promise((res, rej) => {
        try {
          // console.log(new Date().toTimeString().substring(0, 8), "- Carregando", getters.gtxStore.name);
          API.get("Servicos/Stores/Get", { StoreName: getters.gtxStore.name }, false).then((apidata) => {
            let storeUpdate = new Date('02/12/2022'); // para quando não houver data de atualiação da store gravada
            let localUpdate = new Date('01/12/2022');
            const data = API.prepareData(apidata.data);
            if (data.success) {
              storeUpdate = new Date(data.data[0].Updated);
            }
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc) localUpdate = doc.data.updated;
              if (localUpdate > storeUpdate) {
                commit(getters.gtxStore.setter, doc.data);
                res(doc.data);
              } else {
                API.get(getters.gtxStore.route, {}, false).then((apidata) => {
                  const data = API.prepareData(apidata.data);
                  commit(getters.gtxStore.setter, data);
                  API.setLocalDBDocument({ data: data }, getters.gtxStore.name);
                  res(data);
                }).catch((error) => {
                  API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
                    if (doc && doc.data) {
                      commit(getters.gtxStore.setter, doc.data);
                      res(doc.data);
                    } else {
                      const emptyData = { data: [], error: error.message };
                      res(emptyData);
                    }
                  });
                });
              }
            });
          }).catch((error) => {
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc && doc.data) {
                commit(getters.gtxStore.setter, doc.data);
                res(doc.data);
              } else {
                const emptyData = { data: [], error: error.message };
                res(emptyData);
              }
            });
          });
        } catch (err) { rej(err); }});    },
  },
  actMenusSet({ commit }, codigo) {
      //console.log('actMenusSet.codigo', codigo);
      commit("setParempcodigo", codigo);

      API.getLocalDBDocument("globalStore").then((doc) => {
        if (doc && doc.data) {
          doc.data.idMenu = codigo;
          API.setLocalDBDocument({ data: doc.data }, "globalStore");
        } else {
          API.setLocalDBDocument({ data: {idMenu: idMenu} }, "globalStore");
        }
      });
    }
};
